// extracted by css-extract-rspack-plugin
export default {"fullBleedWrapper":"ProductOfferCTACardsGroup_fullBleedWrapper__Y2PWF","row":"ProductOfferCTACardsGroup_row__2TQWH","cardFlex":"ProductOfferCTACardsGroup_cardFlex__RuSbf"};